module.exports = require("glob");


//////////////////
// WEBPACK FOOTER
// external "glob"
// module id = 7
// module chunks = 0